(() => {
function $c22cc53dd67b4d27$var$initAlphabetNavigation() {
    // Early exit: check if retailer cards exist on this page
    const retailerTitles = document.querySelectorAll('[class*="ai-retailer-cards-title"]');
    if (retailerTitles.length === 0) return; // No retailer cards on this page, exit early
    // Function to determine the first letter (skips "The ")
    function getFirstLetter(text) {
        if (!text) return '';
        const upperText = text.toUpperCase();
        if (upperText.startsWith('THE ')) {
            const words = text.split(' ');
            return words.length > 1 ? words[1].charAt(0).toUpperCase() : text.charAt(0).toUpperCase();
        }
        return text.charAt(0).toUpperCase();
    }
    // Create a map of letters -> first block
    const letterToBlockMap = new Map();
    retailerTitles.forEach((title)=>{
        const text = title.textContent.trim();
        const firstLetter = getFirstLetter(text);
        if (firstLetter && !letterToBlockMap.has(firstLetter)) {
            // Find the parent block (ai-retailer-cards container)
            const blockContainer = title.closest('[class*="ai-retailer-cards"]');
            if (blockContainer) letterToBlockMap.set(firstLetter, blockContainer);
        }
    });
    // Find the heading element that contains the alphabet navigation
    // Look for elements with ID starting with "shopify-block-heading" or any heading with alphabet navigation
    const headingSelectors = [
        '[id^="shopify-block-heading"]',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p.h3',
        'p[class*="heading"]'
    ];
    let alphabetHeading = null;
    for (const selector of headingSelectors){
        const elements = document.querySelectorAll(selector);
        for (const heading of elements){
            const text = heading.textContent.trim();
            // Check if it contains alphabet navigation (A B C D... or A  B  C  D...)
            // Look for text that contains only letters A-Z, Æ, Ø, Å and spaces, and has more than 20 characters
            if (text.match(/^[A-ZÆØÅ\s]+$/) && text.length > 20) {
                alphabetHeading = heading;
                break;
            }
        }
        if (alphabetHeading) break;
    }
    if (alphabetHeading && letterToBlockMap.size > 0) {
        // Create wrapper for clickable letters
        const text = alphabetHeading.textContent.trim();
        const letters = text.split(/\s+/).filter((l)=>l.length === 1 && /[A-ZÆØÅ]/.test(l));
        if (letters.length > 0) {
            // Create new HTML with clickable links
            const letterElements = letters.map((letter)=>{
                const hasBlock = letterToBlockMap.has(letter);
                if (hasBlock) return `<a href="#" class="alphabet-nav-link" data-letter="${letter}" style="cursor: pointer; text-decoration: none; color: inherit; transition: opacity 0.2s;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">${letter}</a>`;
                else return `<span style="opacity: 0.3; cursor: not-allowed;">${letter}</span>`;
            }).join('  ');
            alphabetHeading.innerHTML = letterElements;
            // Add event listeners to links
            const links = alphabetHeading.querySelectorAll('.alphabet-nav-link');
            links.forEach((link)=>{
                link.addEventListener('click', (e)=>{
                    e.preventDefault();
                    const letter = link.dataset.letter;
                    const targetBlock = letterToBlockMap.get(letter);
                    if (targetBlock) targetBlock.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
            });
        }
    }
}
function $c22cc53dd67b4d27$var$setupAlphabetNavigation() {
    $c22cc53dd67b4d27$var$initAlphabetNavigation();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $c22cc53dd67b4d27$var$setupAlphabetNavigation);
else $c22cc53dd67b4d27$var$setupAlphabetNavigation();


class $a0665484aaafb5d2$var$DynamicGrid extends HTMLElement {
    connectedCallback() {
        this.handleSectionVisibilityIfNoMediaContent();
    }
    handleSectionVisibilityIfNoMediaContent() {
        // The section is hidden even though it has text content. If no media content is present such as images or videos then the section is hidden'
        const mediaElements = this.querySelectorAll('figure video-media, figure img');
        if (mediaElements.length > 0) this.classList.remove('hidden');
    }
}
if (!customElements.get('dynamic-grid-section')) customElements.define('dynamic-grid-section', $a0665484aaafb5d2$var$DynamicGrid);


function $73f16100d0417850$var$initializeNavigationSwitcher(sectionElement) {
    if (!sectionElement) return;
    const links = sectionElement.querySelectorAll('.navigation_switcher__link');
    if (!links || links.length === 0) return;
    const currentUrl = window.location.href;
    for (const link of links)if (currentUrl.includes(link.dataset.link)) link.classList.add('active');
}
function $73f16100d0417850$var$setupNavigation() {
    const sectionsToInitialize = document.querySelectorAll('[data-section-script="navigation-switcher"]');
    sectionsToInitialize.forEach((section)=>{
        $73f16100d0417850$var$initializeNavigationSwitcher(section);
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $73f16100d0417850$var$setupNavigation);
else $73f16100d0417850$var$setupNavigation();


function $00eba56003c7dd96$var$toggleNotifyModal(force) {
    const modal = document.getElementById('notify-me-modal');
    if (!modal) return;
    if (typeof force === 'boolean') modal.classList.toggle('active', force);
    else modal.classList.toggle('active');
}
function $00eba56003c7dd96$var$bindNotifyButtons() {
    if (document.body.classList.contains('alternative-market')) return;
    document.querySelectorAll('.notify-me-button-overlay').forEach((btn)=>{
        if (btn.closest('a[href]')) return;
        btn.addEventListener('click', (e)=>{
            e.stopPropagation();
            e.preventDefault();
            $00eba56003c7dd96$var$toggleNotifyModal(true);
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    $00eba56003c7dd96$var$bindNotifyButtons();
    document.getElementById('notify-me-modal-close')?.addEventListener('click', ()=>$00eba56003c7dd96$var$toggleNotifyModal(false));
    document.getElementById('notify-me-modal-overlay')?.addEventListener('click', ()=>$00eba56003c7dd96$var$toggleNotifyModal(false));
});
document.addEventListener('variant:change', $00eba56003c7dd96$var$bindNotifyButtons);


function $7771e7d508a998a5$var$initCarousel(carousel) {
    if (carousel.dataset.carouselInitialized) return;
    carousel.dataset.carouselInitialized = 'true';
    const images = carousel.querySelectorAll('.product-card__image');
    const imageWrapper = carousel.querySelector('.product-card__image-wrapper');
    const prevButton = carousel.querySelector('[data-direction="prev"]');
    const nextButton = carousel.querySelector('[data-direction="next"]');
    let currentIndex = 0;
    const updateButtons = ()=>{
        if (images.length <= 1) {
            if (prevButton) prevButton.style.display = 'none';
            if (nextButton) nextButton.style.display = 'none';
            return;
        }
        if (prevButton) {
            prevButton.disabled = currentIndex === 0;
            prevButton.classList.toggle('is-disabled', currentIndex === 0);
        }
        if (nextButton) {
            nextButton.disabled = currentIndex === images.length - 1;
            nextButton.classList.toggle('is-disabled', currentIndex === images.length - 1);
        }
    };
    const showImage = (newIndex)=>{
        currentIndex = newIndex;
        const offset = -currentIndex * 100;
        imageWrapper.style.transform = `translateX(${offset}%)`;
        carousel.dataset.currentIndex = currentIndex;
        updateButtons();
    };
    const goToNext = ()=>{
        if (currentIndex < images.length - 1) showImage(currentIndex + 1);
    };
    const goToPrev = ()=>{
        if (currentIndex > 0) showImage(currentIndex - 1);
    };
    nextButton?.addEventListener('click', goToNext);
    prevButton?.addEventListener('click', goToPrev);
    let touchStartX = 0;
    const swipeThreshold = 50;
    carousel.addEventListener('touchstart', (e)=>{
        const productList = carousel.closest('.product-list');
        const isScrollable = productList && productList.classList.contains('is-scrollable');
        if (isScrollable) {
            touchStartX = null;
            return;
        }
        touchStartX = e.changedTouches[0].screenX;
    }, {
        passive: true
    });
    carousel.addEventListener('touchend', (e)=>{
        if (touchStartX === null) return;
        const touchEndX = e.changedTouches[0].screenX;
        const swipeDistance = touchEndX - touchStartX;
        if (swipeDistance < -swipeThreshold) goToNext();
        else if (swipeDistance > swipeThreshold) goToPrev();
    });
    updateButtons();
}
document.addEventListener('DOMContentLoaded', ()=>{
    const carousels = document.querySelectorAll('[data-card-carousel]');
    carousels.forEach($7771e7d508a998a5$var$initCarousel);
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            mutation.addedNodes.forEach((node)=>{
                if (node.nodeType === 1) node.querySelectorAll('[data-card-carousel]').forEach($7771e7d508a998a5$var$initCarousel);
            });
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


// Utility function to normalize locale paths
function $706f54b4f6c41782$var$normalizeLocalePath(loc) {
    if (loc == null) return "";
    const raw = String(loc).trim();
    if (!raw) return "";
    // Guard against accidentally storing a scheme like "https:" (would become https://products/...)
    // or a full URL. In those cases we only keep the pathname.
    if (/^https?:/i.test(raw)) try {
        const u = new URL(raw);
        return $706f54b4f6c41782$var$normalizeLocalePath(u.pathname);
    } catch  {
        return "";
    }
    // Ensure we only end up with a locale segment like "/en-dk" (or empty string).
    const cleaned = raw.replace(/^\/+|\/+$/g, "");
    if (!cleaned) return "";
    // reject multi-segment paths or scheme-like strings to ensure only a single locale segment like 'en-dk' is accepted
    if (cleaned.includes("/") || cleaned.includes(":")) return "";
    return `/${cleaned}`;
}
class $706f54b4f6c41782$var$ProductConfigurator extends HTMLElement {
    constructor(){
        super();
        // default values
        this.selected = {
            frame: null,
            frameMaterial: null,
            mattress: null,
            size: null,
            addons: null
        };
        // swatches
        this.frameSwatches = [];
        this.frameMaterialSwatches = [];
        this.mattressSwatches = [];
        this.addonSwatches = [];
        this.sizeSwatches = [];
        this.localization;
        // product data
        this.productData = null;
        // NEW: Bind the resize event to a debounced or direct function
        this.onResize = this.checkOverflow.bind(this);
    }
    hasFrameMaterialOption() {
        if (Array.isArray(this.frameMaterialSwatches) && this.frameMaterialSwatches.length > 0) return true;
        if (this.productData && Array.isArray(this.productData.connectedProducts)) return this.productData.connectedProducts.some((p)=>(p?.frameMaterial ?? "") !== "");
        return false;
    }
    normalizeConnectedProduct(p) {
        return {
            raw: p,
            frame: p?.frame?.frameColor ?? "",
            frameMaterial: p?.frameMaterial ?? "",
            mattress: p?.mattress?.mattressColor ?? "",
            size: p?.size ?? "",
            addons: p?.selectedAddons ?? ""
        };
    }
    /**
   * Finds the "best" existing connected product for the current selection.
   * - Keeps the changed option locked (must match)
   * - Prefers keeping the rest of the current selections (size/color/etc) when possible
   * - Falls back to the first available combination when some options/sizes don't exist
   */ findBestMatchingConnectedProduct({ changedKey: changedKey } = {}) {
        if (!this.productData || !Array.isArray(this.productData.connectedProducts)) return null;
        const s = this.selected ?? {};
        const required = {};
        const hasFrameMaterial = this.hasFrameMaterialOption();
        // Lock the option the user just changed (or lock anything that's already set if no key provided)
        if (changedKey) {
            // If this product doesn't support frame material, ignore it entirely.
            if (changedKey === "frameMaterial" && !hasFrameMaterial) ;
            else required[changedKey] = s[changedKey] ?? "";
            // When materials exist, frame color availability depends on the selected material.
            // So a frame color change should keep the current material locked (if set).
            if (changedKey === "frame" && hasFrameMaterial && s.frameMaterial != null) required.frameMaterial = s.frameMaterial ?? "";
        } else [
            "frame",
            "frameMaterial",
            "mattress",
            "size",
            "addons"
        ].forEach((k)=>{
            if (k === "frameMaterial" && !hasFrameMaterial) return;
            if (s[k] != null) required[k] = s[k];
        });
        // Weights express "how much we want to keep" an option when multiple combos exist.
        // Size tends to have the biggest availability gaps (e.g. oak), so we strongly prefer it when it exists.
        const weights = {
            size: 5,
            frame: 4,
            frameMaterial: 4,
            mattress: 3,
            addons: 1
        };
        let best = null;
        let bestScore = -Infinity;
        for (const p of this.productData.connectedProducts){
            const n = this.normalizeConnectedProduct(p);
            // Must satisfy the locked requirement (changed option)
            let ok = true;
            for (const [k, v] of Object.entries(required)){
                const desired = (v ?? "") + "";
                if ((n[k] ?? "") + "" !== desired) {
                    ok = false;
                    break;
                }
            }
            if (!ok) continue;
            // Score by how many of the *other* current selections we can keep
            let score = 0;
            for (const k of [
                "frame",
                "frameMaterial",
                "mattress",
                "size",
                "addons"
            ]){
                if (k === "frameMaterial" && !hasFrameMaterial) continue;
                const current = s[k];
                if (current == null) continue;
                if ((n[k] ?? "") + "" === (current ?? "") + "") score += weights[k] ?? 0;
            }
            if (score > bestScore) {
                bestScore = score;
                best = p;
            }
        }
        return best;
    }
    syncSelectedFromConnectedProduct(match) {
        if (!match) return;
        const n = this.normalizeConnectedProduct(match);
        this.selected.frame = n.frame || null;
        this.selected.frameMaterial = n.frameMaterial || null;
        this.selected.mattress = n.mattress || null;
        this.selected.size = n.size || null;
        this.selected.addons = n.addons || null;
    }
    connectedCallback() {
        // initialize from global productData if available
        if (typeof window !== "undefined" && window.productData && typeof window.productData === "object") {
            this.productData = window.productData;
            this.selected.frame = this.productData.selectedFrame;
            this.selected.frameMaterial = this.productData.selectedFrameMaterial;
            this.selected.mattress = this.productData.selectedMattress;
            this.selected.size = this.productData.selectedSize;
            this.selected.addons = this.productData.selectedAddons;
            this.frameSwatches = this.productData.frameColorObjects;
            this.frameMaterialSwatches = this.productData.frameMaterialObjects;
            this.mattressSwatches = this.productData.mattressColorObjects;
            this.sizeSwatches = this.productData.sizeObjects;
            this.addonSwatches = this.productData.addonObjects;
            this.localization = this.productData.localization;
            this.createOptions();
            this.updateAllSwatchAvailabilities();
        }
        // We use requestAnimationFrame or setTimeout to ensure DOM is rendered
        requestAnimationFrame(()=>{
            this.checkOverflow();
        });
        // NEW: Add resize listener
        window.addEventListener("resize", this.onResize);
        const self = this;
        document.addEventListener("click", function(event) {
            // Selectors for the boundaries and the target element
            const containerSelector = ".product-configurator-option";
            const excludedValueAreaSelector = ".product-configurator-option__item-values";
            const targetButtonSelector = ".product-configurator-option__item-value-drawer__toggle";
            // 1. Check if the click occurred inside the main container
            const isInsideContainer = event.target.closest(containerSelector);
            // 2. Check if the click occurred inside the TWO excluded areas:
            // a) The list of item values
            const isInsideValueArea = event.target.closest(excludedValueAreaSelector);
            // b) The toggle button itself
            // We check the target *itself* and its ancestors against the toggle selector.
            const isToggle = event.target.closest(targetButtonSelector);
            const optionName = isInsideContainer?.dataset?.optionName;
            // If the click is:
            // 1. Inside the main container (isInsideContainer is true)
            // AND
            // 2. NOT inside the value area (isInsideValueArea is null)
            // AND
            // 3. NOT on the toggle button (isToggle is null)
            if (isInsideContainer && !isInsideValueArea && !isToggle) {
                // Find the specific toggle button within the clicked container
                const containerElement = isInsideContainer;
                const toggleButton = containerElement.querySelector(targetButtonSelector);
                // Ensure the toggle button exists before trying to click it
                if (toggleButton) {
                    // Trigger the click action on the toggle button
                    toggleButton.click();
                    // Mattress drawer: re-measure sticky offset after opening
                    if (optionName === "Mattress color") requestAnimationFrame(()=>self.updateMattressColorFiltersStickyTop());
                }
            }
            // If the user clicked the toggle button directly, it won't run the "programmatic click" path above.
            if (isInsideContainer && !isInsideValueArea && isToggle && optionName === "Mattress color") requestAnimationFrame(()=>self.updateMattressColorFiltersStickyTop());
        });
    }
    // NEW: Cleanup listener when element is removed
    disconnectedCallback() {
        window.removeEventListener("resize", this.onResize);
    }
    checkOverflow() {
        const wrappers = this.querySelectorAll(".product-configurator-option__item-value-wrapper");
        wrappers.forEach((wrapper)=>{
            const container = wrapper.querySelector(".product-configurator-option__item-values");
            if (!container) return;
            // 1. Select all direct children (the items)
            const items = Array.from(container.querySelectorAll(".product-configurator-option__drawer-item-value"));
            // 2. RESET: Remove hidden class and existing counters to measure true natural width
            items.forEach((item)=>item.classList.remove("is-overflow-hidden"));
            // 3. Measure
            const wrapperWidth = wrapper.getBoundingClientRect().width;
            // We use a small buffer (2px) to handle browser sub-pixel rendering differences
            const maxRight = wrapper.getBoundingClientRect().left + wrapperWidth;
            let hiddenCount = 0;
            items.forEach((item)=>{
                const itemRect = item.getBoundingClientRect();
                // If the right edge of the item is past the right edge of the wrapper
                // It is either cut off or fully overflowing
                if (itemRect.right > maxRight) {
                    item.classList.add("is-overflow-hidden");
                    hiddenCount++;
                }
            });
            // 4. Add Counter if needed
            if (hiddenCount > 0) {
                const nextSibling = wrapper.nextElementSibling;
                // 4. Check if the sibling exists before setting HTML
                if (nextSibling) nextSibling.innerHTML = `+${hiddenCount}`;
            } else wrapper.nextSibling.innerHTML = "";
        });
        // Mattress drawer (mobile): keep filters pinned directly under the sticky image.
        this.updateMattressColorFiltersStickyTop();
    }
    updateMattressColorFiltersStickyTop() {
        // Only for mobile
        const isDesktop = window.matchMedia("(min-width: 990px)").matches;
        const drawer = document.querySelector("#product-options-mattress-color");
        if (!drawer) return;
        const imageWrapper = drawer.querySelector(".product-configurator-option__drawer-main-image-wrapper");
        const filters = drawer.querySelector(".product-configurator-option__drawer-item-values__filters");
        if (!imageWrapper || !filters) return;
        if (isDesktop) {
            // Remove any previously-set inline top when switching back to desktop.
            filters.style.top = "";
            return;
        }
        const imageHeight = imageWrapper.getBoundingClientRect().height;
        if (!Number.isFinite(imageHeight) || imageHeight <= 0) return;
        // Sticky element: set `top` so it starts exactly after the sticky image.
        filters.style.top = `${imageHeight}px`;
    }
    createOptions() {
        // create options and drawers from productData
        if (this.frameSwatches && this.frameSwatches.length > 0) this.populateSwatches("Frame color", this.frameSwatches, "frame");
        if (this.frameMaterialSwatches && this.frameMaterialSwatches.length > 0) this.populateSwatches("Frame material", this.frameMaterialSwatches, "frameMaterial");
        if (this.mattressSwatches && this.mattressSwatches.length > 0) this.populateSwatches("Mattress color", this.mattressSwatches, "mattress");
        if (this.sizeSwatches && this.sizeSwatches.length > 0) this.populateSwatches("Size", this.sizeSwatches, "size");
        if (this.addonSwatches && this.addonSwatches.length > 0) this.populateSwatches("Addons", this.addonSwatches, "addons");
        this.updateSelectedOnClick();
        this.updateAllSwatchAvailabilities();
        // NEW: Check overflow after creating options
        requestAnimationFrame(()=>{
            this.checkOverflow();
        });
    }
    populateSwatches(optionType, swatches, optionName) {
        // populate swatches from productData
        const target = document.querySelector(`[data-option-name="${optionType}"] .product-configurator-option__item-value-wrapper .product-configurator-option__item-values`);
        const drawerTarget = document.querySelector(`[data-option-name="${optionType}"] .product-configurator-option__drawer-item-values`);
        if (optionName == "size") swatches.sort((a, b)=>{
            // Split by ' x ' and convert to numbers
            // If there is no ' x ', partsA[1] will simply be undefined
            const partsA = a.split(" x ").map(Number);
            const partsB = b.split(" x ").map(Number);
            // 1. Compare the first number (Width)
            if (partsA[0] !== partsB[0]) return partsA[0] - partsB[0];
            // 2. Compare the second number (Length)
            // The "|| 0" ensures that if the second number is missing, we don't get an error
            return (partsA[1] || 0) - (partsB[1] || 0);
        });
        swatches.forEach((swatch)=>{
            let cloneTemplate;
            if (optionName == "size") cloneTemplate = document.querySelector("#product-configurator-option-drawer-item-value-size-template").content.cloneNode(true);
            else cloneTemplate = document.querySelector("#product-configurator-option-drawer-item-value-template").content.cloneNode(true);
            if (optionName == "addons") {
                const clone = cloneTemplate.querySelector(".product-configurator-option__drawer-item-value");
                clone.dataset.value = swatch.addonValue;
                const img = clone.querySelector("img");
                const span = clone.querySelector("span");
                img.src = swatch.addon_img;
                img.alt = swatch.addonValue;
                if (clone.dataset.value == this.selected[optionName]) clone.classList.add("swatch-active");
                span.textContent = swatch.addonValue;
                const cloneDrawer = clone.cloneNode(true);
                cloneDrawer.classList.add("drawer-swatch");
                cloneDrawer.dataset.filterValues = swatch.color_material_name;
                // populate swatches and drawer
                target.appendChild(clone);
                drawerTarget.appendChild(cloneDrawer);
            } else if (optionName == "size") {
                const clone = cloneTemplate.querySelector(".product-configurator-option__drawer-item-value");
                clone.dataset.value = swatch;
                const div = clone.querySelector("div");
                div.textContent = swatch;
                if (clone.dataset.value == this.selected[optionName]) clone.classList.add("swatch-active");
                const cloneDrawer = clone.cloneNode(true);
                cloneDrawer.classList.add("drawer-swatch");
                cloneDrawer.dataset.filterValues = swatch.size_name;
                // // populate swatches and drawer
                target.appendChild(clone);
                drawerTarget.appendChild(clone);
            } else if (optionName == "frameMaterial") {
                const clone = cloneTemplate.querySelector(".product-configurator-option__drawer-item-value");
                clone.dataset.value = swatch.name;
                const img = clone.querySelector("img");
                const span = clone.querySelector("span");
                img.src = swatch.image;
                img.alt = swatch.name;
                if (clone.dataset.value == this.selected[optionName]) clone.classList.add("swatch-active");
                span.textContent = swatch.name;
                const cloneDrawer = clone.cloneNode(true);
                cloneDrawer.classList.add("drawer-swatch");
                // populate swatches and drawer
                target.appendChild(clone);
                drawerTarget.appendChild(cloneDrawer);
            } else {
                const clone = cloneTemplate.querySelector(".product-configurator-option__drawer-item-value");
                clone.dataset.value = swatch.color_name;
                const img = clone.querySelector("img");
                const span = clone.querySelector("span");
                img.src = swatch.color_image;
                img.alt = swatch.color_name;
                if (clone.dataset.value == this.selected[optionName]) clone.classList.add("swatch-active");
                span.textContent = swatch.color_name;
                const cloneDrawer = clone.cloneNode(true);
                cloneDrawer.classList.add("drawer-swatch");
                cloneDrawer.dataset.filterValues = swatch.color_material_name;
                // populate swatches and drawer
                target.appendChild(clone);
                drawerTarget.appendChild(cloneDrawer);
            }
        });
        if (optionType == "Mattress color") this.materialFilters();
    }
    materialFilters() {
        const mattressDrawer = document.querySelector('.drawer[data-option-name="Mattress color"]');
        const swatches = mattressDrawer.querySelectorAll(".product-configurator-option__drawer-item-value");
        const filterCounts = Array.from(swatches).reduce((acc, swatch)=>{
            const value = swatch.getAttribute("data-filter-values");
            if (value) acc[value] = (acc[value] || 0) + 1;
            return acc;
        }, {});
        mattressDrawer.querySelector(".product-configurator-option__drawer-item-values__filters").innerHTML += `<div class="product-configurator-option__drawer-item-value__filter product-configurator-option__drawer-item-value__filter--active " data-filter-values="All">All types (${swatches.length})</div>`;
        Object.entries(filterCounts).forEach(([key, value])=>{
            mattressDrawer.querySelector(".product-configurator-option__drawer-item-values__filters").innerHTML += `<div class="product-configurator-option__drawer-item-value__filter" data-filter-values="${key}">${key} (${value})</div>`;
        });
        mattressDrawer.querySelectorAll(".product-configurator-option__drawer-item-value__filter").forEach((filter)=>{
            filter.addEventListener("click", ()=>{
                mattressDrawer.querySelectorAll(".product-configurator-option__drawer-item-value").forEach((swatch)=>{
                    if (filter.dataset.filterValues == "All") swatch.classList.remove("swatch-hidden");
                    else if (swatch.dataset.filterValues == filter.dataset.filterValues) swatch.classList.remove("swatch-hidden");
                    else swatch.classList.add("swatch-hidden");
                });
                mattressDrawer.querySelectorAll(".product-configurator-option__drawer-item-value__filter").forEach((filter)=>{
                    filter.classList.remove("product-configurator-option__drawer-item-value__filter--active");
                });
                filter.classList.add("product-configurator-option__drawer-item-value__filter--active");
            });
        });
    }
    updateAllSwatchAvailabilities() {
        // Safety check
        if (!this.productData || !this.productData.connectedProducts) return;
        const hasFrameMaterial = this.hasFrameMaterialOption();
        // Select all swatches (both in the main view and in the drawers)
        const swatches = this.querySelectorAll(".product-configurator-option__drawer-item-value");
        swatches.forEach((swatch)=>{
            // 1. Determine which option (frame, mattress, etc) this swatch belongs to
            const container = swatch.closest("[data-option-name]");
            if (!container) return;
            const optionLabel = container.dataset.optionName;
            let internalKey = null;
            // Map the Display Name to the internal 'this.selected' key
            // keeping logic consistent with your updateSelectedOnClick switch
            switch(optionLabel){
                case "Frame color":
                    internalKey = "frame";
                    break;
                case "Frame material":
                    internalKey = "frameMaterial";
                    break;
                case "Mattress color":
                    internalKey = "mattress";
                    break;
                case "Size":
                    internalKey = "size";
                    break;
                case "Addons":
                    internalKey = "addons";
                    break;
            }
            if (!internalKey) return;
            if (internalKey === "frame") {
                // If materials don't exist for this product, keep old behavior: frame is always selectable.
                if (!hasFrameMaterial) {
                    swatch.classList.remove("is-unavailable");
                    return;
                }
                // If materials exist, frame availability depends on the currently selected material AND size.
                // Size is the primary selection: discontinued frame colors for the chosen size must be disabled.
                // When a product has no size option, selectedSize stays empty and the size constraint is skipped.
                const selectedMaterial = this.selected?.frameMaterial ?? "";
                const selectedSize = this.selected?.size ?? "";
                const isCompatibleForMaterial = this.productData.connectedProducts.some((p)=>(p.frame?.frameColor ?? "") === (swatch.dataset.value ?? "") && (p.frameMaterial ?? "") === selectedMaterial && (!selectedSize || (p.size ?? "") === selectedSize));
                if (isCompatibleForMaterial) swatch.classList.remove("is-unavailable");
                else swatch.classList.add("is-unavailable");
                return;
            }
            // Materials must always be clickable so users can switch material anytime.
            // We still resolve to a valid connected-product combination after click.
            if (internalKey === "frameMaterial" && hasFrameMaterial) {
                swatch.classList.remove("is-unavailable");
                return;
            }
            // 2. Create a "Hypothetical" selection
            // Start with current selection, but overwrite the key for this specific swatch
            const testSelection = {
                ...this.selected,
                [internalKey]: swatch.dataset.value
            };
            // 3. Check if this hypothetical combination exists in your data
            const isCompatible = this.productData.connectedProducts.some((p)=>(p.frame?.frameColor ?? "") === (testSelection.frame ?? "") && (!hasFrameMaterial || (p.frameMaterial ?? "") === (testSelection.frameMaterial ?? "")) && (p.mattress?.mattressColor ?? "") === (testSelection.mattress ?? "") && (p.size ?? "") == (testSelection.size ?? "") && (p.selectedAddons ?? "") === (testSelection.addons ?? ""));
            // 4. Toggle the opacity class
            if (isCompatible) swatch.classList.remove("is-unavailable");
            else swatch.classList.add("is-unavailable");
        });
    }
    // Helper to update active swatches based on current state (this.selected)
    updateActiveSwatches() {
        const map = {
            frame: "Frame color",
            frameMaterial: "Frame material",
            mattress: "Mattress color",
            size: "Size",
            addons: "Addons"
        };
        Object.keys(this.selected).forEach((key)=>{
            const val = this.selected[key];
            const name = map[key];
            if (!val || !name) return;
            // Find containers (main view and drawers)
            const containers = this.querySelectorAll(`[data-option-name="${name}"]`);
            containers.forEach((container)=>{
                // Reset active
                container.querySelectorAll(".swatch-active").forEach((el)=>el.classList.remove("swatch-active"));
                // Set new active
                const target = container.querySelector(`[data-value="${val}"]`);
                if (target) {
                    target.classList.add("swatch-active");
                    // Also update the text label above the swatches if it exists
                    const labelSpan = container.querySelector(".product-configurator-option__item-name span");
                    if (labelSpan) labelSpan.textContent = val;
                }
            });
        });
    }
    updateSelectedOnClick() {
        document.querySelectorAll(".product-configurator-option__drawer-item-value").forEach((swatch)=>{
            swatch.addEventListener("click", ()=>{
                const optionName = swatch.closest(".product-configurator-option, .drawer").dataset.optionName;
                let optionNameInternal = optionName;
                const optionValue = swatch.dataset.value;
                switch(optionName){
                    case "Frame color":
                        optionNameInternal = "frame";
                        break;
                    case "Frame material":
                        optionNameInternal = "frameMaterial";
                        break;
                    case "Mattress color":
                        optionNameInternal = "mattress";
                        break;
                    case "Size":
                        optionNameInternal = "size";
                        break;
                    case "Addons":
                        optionNameInternal = "addons";
                        break;
                }
                // Block unavailable swatches for all options EXCEPT frame color and frame material.
                // Frame material must always be clickable when it exists; frame color is only always clickable
                // on products without materials (old behavior).
                const hasFrameMaterial = this.hasFrameMaterialOption();
                const allowUnavailableClick = optionNameInternal === "frameMaterial" || optionNameInternal === "frame" && !hasFrameMaterial;
                if (swatch.classList.contains("is-unavailable") && !allowUnavailableClick) return;
                this.selected[optionNameInternal] = optionValue;
                const options = document.querySelectorAll(`[data-option-name="${optionName}"]`);
                options.forEach((option)=>{
                    if (option.querySelector(".product-configurator-option__item-name")) option.querySelector(".product-configurator-option__item-name span").textContent = optionValue;
                    option.querySelector(".swatch-active")?.classList.remove("swatch-active");
                    option.querySelector(`[data-value="${optionValue}"]`)?.classList.add("swatch-active");
                });
                swatch.parentElement.querySelector(".swatch-active")?.classList.remove("swatch-active");
                swatch.classList.add("swatch-active");
                // After any change (especially frame material), resolve to the first valid existing combination.
                const match = this.findBestMatchingConnectedProduct({
                    changedKey: optionNameInternal
                });
                if (match) {
                    this.syncSelectedFromConnectedProduct(match);
                    this.updateActiveSwatches();
                    this.updateAllSwatchAvailabilities();
                    this.updatePageContent(match);
                } else // Fallback to legacy behavior if something unexpected happens
                this.findMatchingConnectedProduct();
            });
        });
    }
    findMatchingConnectedProduct() {
        const s = this.selected;
        const hasFrameMaterial = this.hasFrameMaterialOption();
        // 1. Try to find an exact match based on ALL criteria
        let match = this.productData.connectedProducts.find((p)=>(p.frame?.frameColor ?? "") === (s.frame ?? "") && (!hasFrameMaterial || (p.frameMaterial ?? "") === (s.frameMaterial ?? "")) && (p.mattress?.mattressColor ?? "") === (s.mattress ?? "") && (p.size ?? "") == (s.size ?? "") && (p.selectedAddons ?? "") === (s.addons ?? ""));
        if (match) this.updatePageContent(match);
        else {
            // 2. Fallback: Find match with Frame + Size + Addons (Ignoring Mattress)
            match = this.productData.connectedProducts.find((p)=>(p.frame?.frameColor ?? "") === (s.frame ?? "") && (!hasFrameMaterial || (p.frameMaterial ?? "") === (s.frameMaterial ?? "")) && // We skip the mattress check here
                (p.size ?? "") == (s.size ?? "") && (p.selectedAddons ?? "") === (s.addons ?? ""));
            if (match) {
                // UPDATE: Sync state with the found product, because the mattress might have changed
                if (match.mattress?.mattressColor) this.selected.mattress = match.mattress.mattressColor;
                if (match.frameMaterial) this.selected.frameMaterial = match.frameMaterial;
                if (match.size) this.selected.size = match.size;
                if (match.selectedAddons) this.selected.addons = match.selectedAddons;
                // UPDATE: Update the visual swatches to match the new state
                this.updateActiveSwatches();
                // UPDATE: Refresh availabilities based on new state
                this.updateAllSwatchAvailabilities();
                this.updatePageContent(match);
            } else console.log("No matching combination found.");
        }
        return match;
    }
    async updatePageContent(match) {
        if (!match || !match.handle) {
            console.warn("Skipping fetch: No match or match.handle provided.");
            return;
        }
        const localePath = $706f54b4f6c41782$var$normalizeLocalePath(this.localization);
        const productPath = `${localePath}/products/${match.handle}`;
        const productUrl = new URL(productPath, window.location.origin).toString();
        try {
            const response = await fetch(productUrl, {
                credentials: "same-origin"
            });
            if (!response.ok) {
                console.warn(`Fetch failed: ${response.status} ${response.statusText}`);
                return;
            }
            const html = await response.text();
            const parser = new DOMParser();
            const fetchedDoc = parser.parseFromString(html, "text/html");
            const newDrawerImg = fetchedDoc.querySelector(".product-configurator-option__drawer-main-image-wrapper img")?.src;
            if (match.addons.length > 0) {
                let addonImages = document.querySelectorAll('[data-option-name="Addons"] .product-configurator-option__item-values > div img');
                let addonDrawerImages = document.querySelectorAll('x-drawer[data-option-name="Addons"] .product-configurator-option__drawer-item-value img');
                match.addons.forEach((addon, index)=>{
                    // Check if the image element exists at this index to prevent errors
                    if (addonImages[index]) {
                        addonImages[index].src = addon.addonImage;
                        addonDrawerImages[index].src = addon.addonImage;
                        // Optional: Update alt text for accessibility
                        addonImages[index].alt = addon.addonValue;
                        addonDrawerImages[index].alt = addon.addonValue;
                    }
                });
            }
            const mainSelector = "main";
            const fetchedMain = fetchedDoc.querySelector(mainSelector);
            if (!fetchedMain) {
                console.warn(`No <${mainSelector}> found in fetched page: ${productUrl}`);
                return;
            }
            const getDirectSections = (root)=>{
                return Array.from(root.children).filter((el)=>el.tagName && el.tagName.toLowerCase() === "section");
            };
            let fetchedSections = getDirectSections(fetchedMain);
            if (fetchedSections.length === 0) {
                console.warn("No direct <section> children found in fetched <main>. Nothing to insert.");
                return;
            }
            const currentMain = document.querySelector(mainSelector);
            if (!currentMain) {
                console.warn(`No <${mainSelector}> found in current document.`);
                return;
            }
            const currentSections = getDirectSections(currentMain);
            // ---------------------------------------------------------
            // NEW LOGIC: Recursive Update with "Black Box" Configurator
            // ---------------------------------------------------------
            const updatePreservedSection = (currentNode, newNode)=>{
                // 1. Basic validation
                if (!currentNode && newNode) return newNode;
                if (!newNode && currentNode) {
                    currentNode.remove();
                    return;
                }
                // 2. STOP CONDITION: Is this the Configurator?
                // If yes, we touch NOTHING. We do not replace it, and we do not enter it.
                // We treat the existing node as the absolute source of truth.
                if (currentNode.nodeType === 1 && currentNode.getAttribute("data-block-type") === "product-configurator") return;
                // 3. PARENT CONDITION: Does this node CONTAIN the Configurator?
                // If yes, we must preserve this specific wrapper node, but we still need to
                // check its children to update the siblings of the configurator.
                const hasConfiguratorInside = currentNode.nodeType === 1 && currentNode.querySelector('[data-block-type="product-configurator"]');
                if (hasConfiguratorInside) {
                    const currentChildren = Array.from(currentNode.children);
                    const newChildren = Array.from(newNode.children);
                    const maxLen = Math.max(currentChildren.length, newChildren.length);
                    for(let i = 0; i < maxLen; i++){
                        const curChild = currentChildren[i];
                        const newChild = newChildren[i];
                        if (!curChild && newChild) // New content has an extra child -> append it
                        currentNode.appendChild(document.importNode(newChild, true));
                        else if (curChild && !newChild) // New content is missing a child -> remove the old one
                        curChild.remove();
                        else // Both exist -> Recurse deeper
                        updatePreservedSection(curChild, newChild);
                    }
                } else // 4. SAFE ZONE:
                // This node is not the configurator, and it does not contain the configurator.
                // We replace it entirely with the new fetched version.
                if (currentNode.outerHTML !== newNode.outerHTML) currentNode.replaceWith(document.importNode(newNode, true));
            };
            // Execute the recursive update on the first section
            if (currentSections.length > 0 && fetchedSections.length > 0) updatePreservedSection(currentSections[0], fetchedSections[0]);
            // ---------------------------------------------------------
            // EXISTING LOGIC: Handle remaining sections (Index 1+)
            // ---------------------------------------------------------
            // Remove the first section from the fetched list (we handled it manually above)
            fetchedSections = fetchedSections.slice(1);
            // Remove all current sections except the first one (which we preserved/updated)
            let removed = 0;
            if (currentSections.length > 1) for(let i = 1; i < currentSections.length; i++){
                currentSections[i].remove();
                removed++;
            }
            // Insert remaining fetched sections after the first current section
            const firstCurrent = currentMain.querySelector(":scope > section");
            let insertionBefore = firstCurrent ? firstCurrent.nextSibling : currentMain.firstChild;
            let inserted = 0;
            for (const sec of fetchedSections){
                const node = document.importNode(sec, true);
                if (insertionBefore) currentMain.insertBefore(node, insertionBefore);
                else currentMain.appendChild(node);
                inserted++;
            }
            // Reactivate product gallery zoom/lightbox by refreshing the custom element
            const productGallery = document.querySelector("product-gallery");
            if (productGallery && productGallery.parentNode) {
                const galleryClone = productGallery.cloneNode(true);
                productGallery.parentNode.replaceChild(galleryClone, productGallery);
            }
            // NEW: Recalculate overflow after page update because layout might shift
            requestAnimationFrame(()=>{
                this.checkOverflow();
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            // Keep History entries same-origin + pretty (path only).
            history.replaceState({
                page: "product"
            }, "", productPath);
            if (newDrawerImg) document.querySelectorAll(".product-configurator-option__drawer-main-image-wrapper img")?.forEach((img)=>{
                img.src = newDrawerImg;
            });
            return {
                inserted: inserted,
                removed: removed
            };
        } catch (err) {
            console.error("updatePageContent error:", err);
            throw err;
        }
    }
}
customElements.define("product-configurator", $706f54b4f6c41782$var$ProductConfigurator);


document.addEventListener('click', (event)=>{
    // Check if the clicked element (or one of its parents) is the button
    const loadMoreButton = event.target.closest('#load-more-button');
    // If the click wasn't on the button, do nothing
    if (!loadMoreButton) return;
    const hiddenImages = document.querySelectorAll('.gallery_images');
    hiddenImages.forEach((image)=>{
        image.hidden = false;
    });
    const loadMoreContainer = document.getElementById('load-more-container');
    if (loadMoreContainer) loadMoreContainer.hidden = true;
});


const $af52ada35dfe91a8$var$STORAGE_KEY = 'theme:geo-location-dismissed';
const $af52ada35dfe91a8$var$DISMISS_DURATION_MS = 2592000000;
function $af52ada35dfe91a8$var$isDismissed() {
    const raw = localStorage.getItem($af52ada35dfe91a8$var$STORAGE_KEY);
    if (!raw) return false;
    try {
        const { timestamp: timestamp } = JSON.parse(raw);
        return Date.now() - timestamp < $af52ada35dfe91a8$var$DISMISS_DURATION_MS;
    } catch  {
        return false;
    }
}
function $af52ada35dfe91a8$var$setDismissed() {
    localStorage.setItem($af52ada35dfe91a8$var$STORAGE_KEY, JSON.stringify({
        timestamp: Date.now()
    }));
}
function $af52ada35dfe91a8$var$escapeAttr(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $af52ada35dfe91a8$var$updateLocalization({ country: country, language: language }) {
    const formId = crypto.randomUUID();
    const returnTo = window.location.pathname + window.location.search;
    const safeFormId = $af52ada35dfe91a8$var$escapeAttr(formId);
    const safeCountry = $af52ada35dfe91a8$var$escapeAttr(country);
    const safeReturnTo = $af52ada35dfe91a8$var$escapeAttr(returnTo);
    const languageField = language ? `<input name="locale_code" value="${$af52ada35dfe91a8$var$escapeAttr(language)}" />` : '';
    document.body.insertAdjacentHTML('beforeend', `<form id="${safeFormId}" action="${window.Shopify.routes.root}localization" method="POST" hidden>
      <input name="_method" value="PUT" />
      <input name="country_code" value="${safeCountry}" />
      <input name="return_to" value="${safeReturnTo}" />
      ${languageField}
    </form>`);
    document.getElementById(formId).submit();
}
function $af52ada35dfe91a8$var$normalizeCode(code) {
    return (code || '').toLowerCase();
}
function $af52ada35dfe91a8$var$countryCodesMatch(a, b) {
    return $af52ada35dfe91a8$var$normalizeCode(a) === $af52ada35dfe91a8$var$normalizeCode(b);
}
/**
 * Shows the modal only when Shopify detects a different country than the one
 * the visitor is browsing. Uses Liquid-rendered country (theme editor "View as")
 * instead of window.Shopify.country.
 */ async function $af52ada35dfe91a8$var$shouldShowGeoModal(localizationData) {
    const currentCountry = localizationData?.currentCountry;
    if (!currentCountry) return {
        show: false,
        reason: 'no_current_country'
    };
    const params = new URLSearchParams({
        'country[enabled]': 'true',
        'country[exclude]': currentCountry
    });
    const apiUrl = `${window.Shopify.routes.root}browsing_context_suggestions.json?${params.toString()}`;
    const response = await fetch(apiUrl);
    if (!response.ok) return {
        show: false,
        reason: 'api_error',
        status: response.status
    };
    const data = await response.json();
    const detectedCountry = data.detected_values?.country?.handle;
    const suggestedCountry = data.suggestions?.[0]?.parts?.country?.handle;
    const suggestedLanguage = data.suggestions?.[0]?.parts?.language?.handle;
    const inferredCountry = suggestedCountry && !$af52ada35dfe91a8$var$countryCodesMatch(suggestedCountry, currentCountry) ? suggestedCountry : detectedCountry;
    if (!inferredCountry || $af52ada35dfe91a8$var$countryCodesMatch(inferredCountry, currentCountry)) return {
        show: false,
        reason: 'country_match',
        detectedCountry: detectedCountry,
        suggestedCountry: suggestedCountry,
        inferredCountry: inferredCountry
    };
    return {
        show: true,
        country: inferredCountry,
        language: suggestedLanguage,
        reason: 'country_mismatch'
    };
}
function $af52ada35dfe91a8$var$isStorefrontThemePreview() {
    return window.location.search.includes('preview_theme_id=');
}
function $af52ada35dfe91a8$var$registerGeoLocationModal(Modal) {
    if (window.customElements.get('geo-location-modal')) return;
    class GeoLocationModalElement extends Modal {
        connectedCallback() {
            super.connectedCallback();
            const overlay = this.getShadowPartByName('overlay');
            if (overlay) overlay.replaceWith(overlay.cloneNode(true));
            this.#localizationData = this.#readLocalizationData();
            this.#bindControls();
            this.#bindPopoverScroll();
            this.#init();
        }
        get shouldAppendToBody() {
            return false;
        }
        get clickOutsideDeactivates() {
            return false;
        }
        get shouldTrapFocus() {
            return true;
        }
        get escapeDeactivates() {
            return true;
        }
        #localizationData = null;
        #selectedCountry = null;
        #selectedLanguage = null;
        #countryTrigger = this.querySelector('[data-geo-trigger="country"]');
        #languageTrigger = this.querySelector('[data-geo-trigger="language"]');
        #countryTriggerLabel = this.#countryTrigger?.querySelector('[data-geo-trigger-label]');
        #countryTriggerFlagSlot = this.#countryTrigger?.querySelector('[data-geo-trigger-flag]');
        #languageTriggerLabel = this.#languageTrigger?.querySelector('[data-geo-trigger-label]');
        #languageList = this.querySelector('[data-geo-language-list]');
        #acceptButton = this.querySelector('.geo-location-modal__accept');
        #readLocalizationData() {
            const dataElement = document.querySelector('[data-geo-localization]');
            if (!dataElement) return null;
            try {
                return JSON.parse(dataElement.textContent);
            } catch  {
                return null;
            }
        }
        #getCountryData(isoCode) {
            return this.#localizationData?.countries?.find((country)=>country.isoCode === isoCode);
        }
        #bindPopoverScroll() {
            const mobileQuery = window.matchMedia('(max-width: 999px)');
            this.querySelectorAll('.geo-location-modal__popover').forEach((popover)=>{
                const getSelectorParent = ()=>this.querySelector(`[aria-controls="${popover.id}"]`)?.closest('.geo-location-modal__selector');
                popover.addEventListener('dialog:after-show', ()=>{
                    if (mobileQuery.matches) {
                        const selector = getSelectorParent();
                        if (selector) selector.append(popover);
                    }
                    const scrollContainer = popover.getShadowPartByName('body');
                    scrollContainer?.addEventListener('wheel', (event)=>event.stopPropagation(), {
                        passive: true
                    });
                });
            });
        }
        #bindControls() {
            this.addEventListener('click', (event)=>{
                const countryButton = event.target.closest('[data-geo-country]');
                const languageButton = event.target.closest('[data-geo-language]');
                if (countryButton) {
                    event.preventDefault();
                    this.#setCountry(countryButton.getAttribute('data-geo-country'), null, {
                        useMarketDefaultLanguage: true
                    });
                    this.#hidePopoverForTrigger(this.#countryTrigger);
                }
                if (languageButton) {
                    event.preventDefault();
                    this.#setLanguage(languageButton.getAttribute('data-geo-language'));
                    this.#hidePopoverForTrigger(this.#languageTrigger);
                }
            });
            this.#acceptButton?.addEventListener('click', ()=>this.#onAccept());
            this.addEventListener('dialog:after-hide', ()=>{
                if (!this.#accepted) $af52ada35dfe91a8$var$setDismissed();
            });
        }
        #accepted = false;
        #matchLanguageCode(languageCode, languages) {
            if (!languageCode || !languages?.length) return null;
            const normalizedCode = languageCode.toLowerCase();
            return languages.find((language)=>{
                const optionCode = language.isoCode.toLowerCase();
                return optionCode === normalizedCode || optionCode.startsWith(`${normalizedCode}-`) || normalizedCode.startsWith(`${optionCode}-`);
            });
        }
        #getCountryLabel(country) {
            if (!country) return '';
            const symbol = country.currencySymbol ? ` ${country.currencySymbol}` : '';
            return `${country.name} (${country.currencyIso}${symbol})`;
        }
        #renderCountryFlag(countryData) {
            const slot = this.#countryTriggerFlagSlot;
            if (!slot) return;
            slot.replaceChildren();
            if (countryData?.flagUrl) {
                const img = document.createElement('img');
                img.className = 'country-flag';
                img.src = countryData.flagUrl;
                img.alt = '';
                img.width = 30;
                img.height = 20;
                img.loading = 'lazy';
                slot.appendChild(img);
                return;
            }
            const placeholder = document.createElement('span');
            placeholder.className = 'country-flag country-flag--placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            slot.appendChild(placeholder);
        }
        #hidePopoverForTrigger(trigger) {
            const popoverId = trigger?.getAttribute('aria-controls');
            if (!popoverId) return;
            const popover = document.getElementById(popoverId);
            if (popover && typeof popover.hide === 'function') popover.hide();
        }
        #getMarketDefaultLanguageIso(countryData, languages) {
            if (countryData?.defaultLanguageIso) return countryData.defaultLanguageIso;
            return languages[0]?.isoCode ?? null;
        }
        #resolveLanguageForCountry(countryData, languages, preferredLanguage, useMarketDefaultLanguage) {
            const marketDefault = this.#getMarketDefaultLanguageIso(countryData, languages);
            if (useMarketDefaultLanguage) return marketDefault;
            if (preferredLanguage) return this.#matchLanguageCode(preferredLanguage, languages)?.isoCode ?? marketDefault;
            return this.#matchLanguageCode(this.#selectedLanguage, languages)?.isoCode ?? marketDefault;
        }
        #setCountry(countryIso, preferredLanguage, { useMarketDefaultLanguage: useMarketDefaultLanguage = false } = {}) {
            const countryData = this.#getCountryData(countryIso);
            if (!countryData) return;
            this.#selectedCountry = countryIso;
            if (this.#countryTriggerLabel) this.#countryTriggerLabel.textContent = this.#getCountryLabel(countryData);
            this.#renderCountryFlag(countryData);
            this.querySelectorAll('[data-geo-country]').forEach((button)=>{
                button.setAttribute('aria-selected', button.getAttribute('data-geo-country') === countryIso ? 'true' : 'false');
            });
            const languages = countryData.languages ?? [];
            const languageToSelect = this.#resolveLanguageForCountry(countryData, languages, preferredLanguage, useMarketDefaultLanguage);
            this.#updateLanguageList(languages, languageToSelect);
        }
        #setLanguage(languageIso) {
            if (!languageIso) return;
            this.#selectedLanguage = languageIso;
            if (this.#languageTriggerLabel) {
                const languageData = this.#getCountryData(this.#selectedCountry)?.languages?.find((language)=>language.isoCode === languageIso);
                this.#languageTriggerLabel.textContent = languageData?.name ?? languageIso;
            }
            this.querySelectorAll('[data-geo-language]').forEach((button)=>{
                button.setAttribute('aria-selected', button.getAttribute('data-geo-language') === languageIso ? 'true' : 'false');
            });
            if (this.#languageTrigger) this.#languageTrigger.disabled = false;
        }
        #updateLanguageList(languages, preferredLanguage) {
            if (!this.#languageList) return;
            this.#languageList.replaceChildren();
            if (!languages.length) {
                this.#selectedLanguage = null;
                if (this.#languageTrigger) this.#languageTrigger.disabled = true;
                if (this.#languageTriggerLabel) this.#languageTriggerLabel.textContent = '';
                return;
            }
            for (const language of languages){
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'popover__value-option subheading link-faded-reverse';
                button.setAttribute('role', 'option');
                button.setAttribute('data-geo-language', language.isoCode);
                const label = document.createElement('span');
                label.textContent = language.name;
                button.appendChild(label);
                this.#languageList.appendChild(button);
            }
            const matchedLanguage = this.#matchLanguageCode(preferredLanguage, languages);
            this.#setLanguage(matchedLanguage?.isoCode ?? languages[0].isoCode);
        }
        async #init() {
            if (this.#localizationData?.currentCountry) this.#setCountry(this.#localizationData.currentCountry, this.#localizationData.currentLanguage);
            // Theme customizer (admin): skip geo detection. Storefront preview (?preview_theme_id=) runs normally.
            if (Shopify.designMode && !$af52ada35dfe91a8$var$isStorefrontThemePreview()) return;
            if ($af52ada35dfe91a8$var$isDismissed()) return;
            const result = await $af52ada35dfe91a8$var$shouldShowGeoModal(this.#localizationData);
            const { show: show, country: country } = result;
            if (!show) return;
            if (!country || !this.#getCountryData(country)) return;
            this.#setCountry(country, null, {
                useMarketDefaultLanguage: true
            });
            this.show();
        }
        #onAccept() {
            if (!this.#selectedCountry) return;
            this.#accepted = true;
            $af52ada35dfe91a8$var$setDismissed();
            $af52ada35dfe91a8$var$updateLocalization({
                country: this.#selectedCountry,
                language: this.#languageTrigger?.disabled ? undefined : this.#selectedLanguage
            });
        }
    }
    window.customElements.define('geo-location-modal', GeoLocationModalElement);
}
function $af52ada35dfe91a8$var$initGeoLocationModal() {
    const modalElement = document.querySelector('geo-location-modal');
    const localizationScript = document.querySelector('[data-geo-localization]');
    if (!modalElement) return;
    const themeModuleUrl = localizationScript?.dataset.themeModule;
    if (!themeModuleUrl) return;
    import(/* @vite-ignore */ themeModuleUrl).then(({ Modal: Modal })=>{
        $af52ada35dfe91a8$var$registerGeoLocationModal(Modal);
    }).catch(()=>{});
}
$af52ada35dfe91a8$var$initGeoLocationModal();


class $029e8dd521b861f3$var$ReadMore extends HTMLElement {
    connectedCallback() {
        this.readMoreButton = this.parentElement.querySelector('.read-more-button');
        this.readMoreButton && this.readMoreButton.addEventListener('click', this.handleReadMoreClick.bind(this));
        this.readLessButton = this.parentElement.querySelector('.read-less-button');
        this.readLessButton && this.readLessButton.addEventListener('click', this.handleReadLessClick.bind(this));
        this.distanceFromTop = 0;
        const offsetHeight = this.readMoreButton?.offsetHeight || 0;
        const marginTop = parseFloat(window.getComputedStyle(this.readMoreButton).marginTop) || 0;
        this.heightOfReadMoreButton = offsetHeight + marginTop;
        this.style.visibility = 'visible';
        this.handleHeightBasedOnFirstParagraph();
        this.resizeObserver = new ResizeObserver(()=>{
            this.handleHeightBasedOnFirstParagraph();
        });
        this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    handleReadMoreClick() {
        if (!this.readMoreButton) return;
        this.resizeObserver.disconnect(); // Disconnect the observer to prevent updating the height when the read more button is clicked
        this.style.maxHeight = 'none';
        this.parentElement.style.height = 'auto';
        this.readMoreButton.classList.add('hidden');
        this.readLessButton.classList.remove('hidden');
    }
    handleReadLessClick() {
        if (!this.readLessButton) return;
        this.resizeObserver.observe(this);
        this.readLessButton.classList.add('hidden');
        this.readMoreButton.classList.remove('hidden');
    }
    handleHeightBasedOnFirstParagraph() {
        const firstParagraph = this.querySelector('p');
        if (!firstParagraph) {
            console.warn('Variable paragraph not found');
            return;
        }
        const paragraphRect = firstParagraph.getBoundingClientRect();
        const parentRect = this.getBoundingClientRect();
        // The distance from the top of the parent element to bottom of the first paragraph
        this.distanceFromTop = paragraphRect.top - parentRect.top + paragraphRect.height;
        this.style.maxHeight = `${this.distanceFromTop}px`;
        this.parentElement.style.height = `${this.distanceFromTop + this.heightOfReadMoreButton}px`;
    }
}
if (!window.customElements.get('read-more')) window.customElements.define('read-more', $029e8dd521b861f3$var$ReadMore);


function $dae90bab2812d3c5$var$removeAssitant() {
    const menuButton = document.querySelector('.header__primary-nav button');
    if (menuButton) menuButton.addEventListener('click', ()=>{
        const launcher = document.querySelector('iframe#launcher');
        if (launcher) launcher.classList.add('launcher--z-index-2');
    });
}
$dae90bab2812d3c5$var$removeAssitant();


const $a21f004597d45d97$var$B2B_SESSION_KEY = 'karup_b2b_session';
class $a21f004597d45d97$var$B2BSession extends HTMLElement {
    connectedCallback() {
        const isB2B = this.dataset.b2bCustomer === 'true';
        if (isB2B) localStorage.setItem($a21f004597d45d97$var$B2B_SESSION_KEY, JSON.stringify(isB2B));
        else localStorage.removeItem($a21f004597d45d97$var$B2B_SESSION_KEY);
    }
}
if (!window.customElements.get("b2b-session")) window.customElements.define("b2b-session", $a21f004597d45d97$var$B2BSession);



})();
//# sourceMappingURL=parcel_scripts.js.map
